import useComicActivity from './useComicActivity.hook';
import {
  StyledComicActivity,
  StyledComicFullscreenBackground,
} from './ComicActivity.styled';
import ComicPlayer from '@/shared/Players/ComicPlayer/ComicPlayer';
import AspectRatio from '@/shared/AspectRatio/AspectRatio';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import { useContext } from 'react';
import useIsMobile from '@/hooks/useIsMobile';

export default function ComicActivity({
  activity,
  taskProgressActions,
  initialTaskProgress,
  isTaskActivityDone,
  // demoMode,
}) {
  const fullscreenContext = useContext(FullscreenContext);
  const isMobile = useIsMobile();
  const { state, actions } = useComicActivity({
    activity,
    taskProgressActions,
  });

  return (
    <>
      <StyledComicFullscreenBackground />
      <StyledComicActivity
        className={`${
          fullscreenContext.state.isFullscreen ? 'fullscreen' : ''
        }`}
      >
        <AspectRatio
          ratio={
            4 /
            (fullscreenContext.state.isFullscreen
              ? isMobile
                ? 2.9
                : 3.2
              : 3.3)
          }
        >
          <ComicPlayer
            pages={activity?.data?.pages}
            onStart={actions.onActivityStart}
            onProgress={actions.onActivityProgress}
            onRestart={actions.onActivityRestart}
            initialCue={initialTaskProgress?.currentCue}
            canMoveForward={
              taskProgressActions
                ? isTaskActivityDone
                : !state.isGamificationStudent
            }
            key={activity?.id}
          />
        </AspectRatio>
      </StyledComicActivity>
    </>
  );
}
